import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';

export const praRoutes: Routes = [
  {
    path: 'perda',
    loadChildren: () =>
      import('../pages/pra/perda/perda.module').then(
        (module) => module.PerdaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'registros',
    loadChildren: () =>
      import('../pages/pra/registros/registros.module').then(
        (module) => module.RegistrosModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'lote',
    loadChildren: () =>
      import('../pages/pra/lote/lote.module').then(
        (module) => module.LoteModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'galpao',
    loadChildren: () =>
      import('../pages/pra/galpao/galpao.module').then(
        (module) => module.GalpaoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import(
        '../pages/cad/cadastro-generico/cadastro-generico.module'
      ).then((module) => module.CadastroGenericoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'integrado',
    loadChildren: () =>
      import('../pages/pra/integrado/integrado.module').then(
        (module) => module.IntegradoModule
      ),
    canActivate: [AuthGuard],
  },
];
